/**
 * 活动指标
 **/

import React from 'react';
import {Map, Marker} from "react-amap";
import Geolocation from 'react-amap-plugin-geolocation';


class EvtAddressMap extends React.Component {
    constructor(props) {
        super(props);
        const _this = this;
        this.map = null;
        this.marker = null;
        this.geocoder = null;
        this.autocomplete = null;
        this.state = {
            mounted: false,
            isFirstGeo: true,
            position: this.props.position,
            currentLocation: this.props.location,
        };
        this.mapPlugins = ['ToolBar'];
        this.markerEvents = {
            click: () => {
                console.log('marker clicked!')

            },
            created: (ins) => {
                console.log('marker created!', ins)
                _this.map.setZoom(17);
                const p = this.state.position && this.state.position.longitude && this.state.position.latitude ? this.state.position : {longitude: 116.390046, latitude: 39.999976};
                _this.map.setCenter(new window.AMap.LngLat(p.longitude || p.lng, p.latitude || p.lat));
            },
        }
        this.autocompleteSearch = (location, callback) => {
            if (location) {
                _this.autocomplete.search(location, callback);
            }
        }
        this.mapEvents = {
            created: (mapInstance) => {
                _this.map = mapInstance;
                console.log(mapInstance)
                window.AMap.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder'], function () {
                    _this.geocoder = new window.AMap.Geocoder({
                        city: "010"//城市，默认：“全国”
                    });
                    var autoOptions = {
                        datatype: "poi"
                    };
                    _this.autocomplete = new window.AMap.Autocomplete(autoOptions);
                    window.AMap.event.addListener(_this.autocomplete, "select", function (e) {
                        mapInstance.setZoom(17);
                        mapInstance.setCenter(e.poi.location);

                        const location = e.poi.district ? (e.poi.district + e.poi.address + e.poi.name) : e.poi.name;
                        _this.setState({
                            position: e.poi.location,
                            currentLocation: location,
                        }, () => {
                            _this.props.onChange(e.poi.location, location)
                        });

                    });

                });
            },
            click: (e) => {
                if (_this.props.readOnly)
                    return;
                const lnglat = e.lnglat;
                _this.setState({
                    position: {
                        longitude: lnglat.longitude || lnglat.lng,
                        latitude: lnglat.latitude || lnglat.lat,
                        lng: lnglat.longitude || lnglat.lng,
                        lat: lnglat.latitude || lnglat.lat
                    },
                    currentLocation: '读取中...'
                });
                _this.geocoder && _this.geocoder.getAddress(lnglat, (status, result) => {
                    console.log(result);
                    if (status === 'complete') {
                        if (result.regeocode) {
                            const formattedAddress = result.regeocode.formattedAddress || '未知地点';
                            _this.setState({
                                currentLocation: formattedAddress
                            }, () => {
                                _this.props.onChange(lnglat, formattedAddress)
                            });
                        } else {
                            _this.setState({
                                currentLocation: '未知地点'
                            });
                        }
                    } else {
                        _this.setState({
                            currentLocation: '未知地点'
                        });
                    }

                })
            }
        }
        this.geolocationEvents = {
            created: (geolocation) => {
                window.AMap.event.addListener(geolocation, 'complete', (e) => {
                    if (_this.state.position == null) {
                        _this.setState({
                            position: {
                                longitude:  e.position.longitude ||  e.position.lng,
                                latitude:  e.position.latitude ||  e.position.lat,
                                lng:  e.position.longitude ||  e.position.lng,
                                lat:  e.position.latitude ||  e.position.lat
                            },
                            currentLocation: e.formattedAddress
                        }, () => {
                            _this.map.setZoom(17);
                            _this.map.setCenter(e.position);
                            _this.props.onChange(e.position, e.formattedAddress)
                        });
                    }
                    if (!_this.state.isFirstGeo) {
                        _this.map.setCenter(e.position);
                    }

                    _this.setState({
                        isFirstGeo: false
                    })
                });
            }
        }

        this.geolocationPluginProps = {
            enableHighAccuracy: true,
            timeout: 10000,
            GeoLocationFirst: true,
            showButton: true,
            panToLocation: false,
        }


        this.setValue = (position, location, triggerChange = false) => {
            this.setState({
                position: position,
                currentLocation: location
            }, () => {
                if (triggerChange) {
                    _this.map.setZoom(17);
                    _this.map.setCenter(position);
                    _this.props.onChange(position, location)
                }
            })
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        })
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {

        return this.state.mounted ? <Map amapkey={"d627dbf5b2f3274c044562a37ca42d95"} events={this.mapEvents}>
            {this.props.geolocation && <Geolocation {...this.geolocationPluginProps} events={this.geolocationEvents}/>}
            <Marker
                events={this.markerEvents}
                position={this.state.position && this.state.position.longitude && this.state.position.latitude ? {
                        longitude: this.state.position.longitude || this.state.position.lng,
                        latitude: this.state.position.latitude || this.state.position.lat,
                        lng: this.state.position.longitude || this.state.position.lng,
                        lat: this.state.position.latitude || this.state.position.lat
                    } :
                    {
                        longitude: 116.390046,
                        latitude: 39.999976,
                        lng: 116.390046,
                        lat: 39.999976
                    }}
                visible={true}
                clickable={this.props.readOnly ? false : true}
                draggable={this.props.readOnly ? false : true}
            />
        </Map> : null


    }


}

EvtAddressMap.contextTypes = {};

EvtAddressMap.defaultProps = {
    geolocation:true,//是否开启定位
    location: "",
    position: null,
    readOnly: false,
    onChange: (position, currentLocation) => {
        console.log(currentLocation)
    },
};

EvtAddressMap.propTypes = {}


export default EvtAddressMap;


// WEBPACK FOOTER //
// ./src/containers/evt/EvtAddressMap.jsx